/** Coordonnées de l'équipe ExpertDevis BTP, publiées sur le site. */
export const SUPPORT = {
  email: 'expertdevisbtp@gmail.com',
  phone: '+235 62 37 99 99',
  whatsappUrl: 'https://wa.me/23562379999',
};
